module.exports = __webpack_public_path__ + "media/images/curriculum_matome-61e9d7158d3f515e6821cb611a1dbd2a.png";